import { useRouter } from 'expo-router';
import PSCircleButton from './ui/PSCircleButton';
import PSIcon from './ui/PSIcon';

export function PSHeaderBackButton({
  variant = 'dark',
}: {
  variant?: 'light' | 'dark';
}) {
  const router = useRouter();
  return (
    <PSCircleButton
      variant="bare"
      onPress={() => (router.canGoBack() ? router.back() : router.push('/'))}
    >
      <PSIcon
        name="arrow-back"
        color={variant === 'light' ? '$borderColor' : undefined}
      />
    </PSCircleButton>
  );
}

export function PSHeaderBackButtonOnTransparentHeader() {
  const router = useRouter();
  return (
    <PSCircleButton
      onPress={() => (router.canGoBack() ? router.back() : router.push('/'))}
      variant="normal"
      filled
    >
      <PSIcon name="arrow-back" />
    </PSCircleButton>
  );
}

export function PSHeaderSettingsButton({ onPress }: { onPress: () => void }) {
  return (
    <PSCircleButton variant="bare" onPress={onPress}>
      <PSIcon name="settings-outline" />
    </PSCircleButton>
  );
}
